import { cancelAuction } from '@/services/Auction/auction-blockchain';
import toast from 'react-hot-toast';
import { useWeb3ModalProvider } from '@web3modal/ethers5/react';
import { BaseModal, Button, Flex } from '@/lib';
import styles from './RemoveFromSaleModal.module.scss';

export const RemoveFromSaleModal = ({ onClose, cardData }) => {
  const { walletProvider } = useWeb3ModalProvider();

  const handleCancelAuction = async () => {
    try {
      toast.loading('Cancelling auction');

      await cancelAuction({
        collectionAddress: cardData?.collection_address,
        nftId: cardData?.token_id,
        walletProvider,
      });
      toast.dismiss();
      toast.success('Successfully removed from sale');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.dismiss();
      toast.error('Error cancelling auction');
    }

    onClose();
  };

  return (
    <BaseModal
      isOpen={true}
      onClose={onClose}
      title="Do you want to remove your NFT from sale?"
      noCloseButton
      width="380px"
    >
      <Flex vertical>
        <div className={styles.subtitle}>You can put it on sale anytime</div>
        <Button size="small" fullWidth onClick={handleCancelAuction}>
          Remove from sale
        </Button>
        <Button variant="ghost" size="small" fullWidth onClick={onClose}>
          Cancel
        </Button>
      </Flex>
    </BaseModal>
  );
};
